import script from "./examTestDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./examTestDetails.vue?vue&type=script&lang=ts&setup=true"

import "./examTestDetails.vue?vue&type=style&index=0&id=ef20d358&lang=less&scoped=true"

import exportComponent from "D:\\officialWebsite\\web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef20d358"]])

export default __exports__